import { FieldConditions } from '../constants/frontend-enums';
import { FieldsContainer } from '../styled/automation-rules.style';
import { DropdownField, DropdownFieldProps } from './fields/dropdown-field.component';
import { InputField, InputFieldProps } from './fields/input-field.component';
import { MultipleSelectField, MultipleSelectFieldProps } from './fields/multiple-select-field.component';
import { SingleSelectField, SingleSelectFieldProps } from './fields/single-select-field.component';

export type { BaseProps } from './field-conditional.type';

const noWrapConditions = new Set<FieldConditions>([FieldConditions.singleSelect, FieldConditions.multipleSelect]);

type FieldConditionalProps = MultipleSelectFieldProps | SingleSelectFieldProps | DropdownFieldProps | InputFieldProps;

const fieldComponentMap: {
    [FieldConditions.multipleSelect]: React.FC<MultipleSelectFieldProps>;
    [FieldConditions.singleSelect]: React.FC<SingleSelectFieldProps>;
    [FieldConditions.dropdown]: React.FC<DropdownFieldProps>;
    [FieldConditions.input]: React.FC<InputFieldProps>;
} = {
    [FieldConditions.multipleSelect]: MultipleSelectField,
    [FieldConditions.singleSelect]: SingleSelectField,
    [FieldConditions.dropdown]: DropdownField,
    [FieldConditions.input]: InputField,
};

export const FieldConditional = (props: FieldConditionalProps) => {
    const { fieldCondition } = props;
    if (!fieldCondition) {
        return null;
    }

    const Component = fieldComponentMap[fieldCondition] as React.FC<typeof props>;
    const shouldWrap = !noWrapConditions.has(fieldCondition);

    const content = <Component {...props} />;

    return shouldWrap ? <FieldsContainer>{content}</FieldsContainer> : content;
};
